/* eslint-disable max-len */
export default {
    BaseSaveToWorkspace: {
        Main: {
            cancel: 'Cancel',
            submit: 'Confirm',
            saveToWorkspaceLink: 'Adding documents now. Go to workspace folder "{link}" to view saved documents.',
            title: 'Save to Workspace',
        },
        FolderSelector: {
            label: 'Select a folder',
            addWorkspace: 'New Workspace',
            searchType: {
                workspace: 'Search workspaces',
                folder: 'Search folders',
            },
            placeholder: 'Please input the name',
            noData: {
                workspace: 'No workspace',
                folder: 'No folder',
                searchFolder: 'No folders found',
                searchSpace: 'No workspaces found',
            },
            newFolderName: 'New folder',
            newWorkspaceName: 'New Workspace',
            workspaceGroupType: {
                public: 'Company workspaces',
                shared: 'Shared workspaces',
                self: 'Personal workspaces',
            },
            lastFlag: {
                ADD: 'Latest saved',
                COPY: 'Latest copied',
                MOVE: 'Latest moved',
                RELATED: 'Project linked',
            },
        },
        RangeSelector: {
            from: 'From',
            to: 'to',
            title: 'Please select',
            selectAllLabel: 'Select All',
            family: {
                label: 'Save all patents and their families',
                types: {
                    SIMPLE: 'All patents and their simple families',
                    INPADOC: 'All patents and their INPADOC families',
                    EXTEND: 'All patents and their PatSnap families',
                    APNO: 'All patents and other records with the same app. number',
                },
                error: 'Family data exception，please cancel then try again.',
            },
            tip: 'If the search results are set to display in groups by families or documents, the patents selected by the scope are representative patents.',
            selectAllFamilyLabel: 'Select all {allCounts} families',
            selectAllFamilyPatentCountLabel: '<span style="color: #8993A4">({count} patent records)</span>',
            familyLabel: '({count} patent records) ',
            selectFamilyLabel: 'Select {allCounts} families <span style="color: #8993A4">({count} patent records)</span>',
        },
        AutoUpdate: {
            otherSettingLabel: 'Other settings',
            label: 'Automatically update the Workspace when there are new patents',
            viewQuery: 'View query',
            tip: 'Auto-update cannot be turned on for a folder that already has auto-update on. Auto-update can be turned only when all patents are selected and not including families.',
            refine: 'Refine',
            familylabel: 'Automatically update the folder when there are new families',
            familyTip: 'Automatic update cannot be turned on for a folder that already has automatic update on',
        },
        PAPER: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> literature has been selected.',
                error: {
                    invalidError: 'Please enter a valid range',
                    overMaxCountError: 'The value of the entered range cannot exceed {limit}',
                    rangeError: 'Up to {limit} records can be saved at one time',
                },
            },
        },
        PATENT: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> patent(s) has been selected',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.rangeError',
                    disabledSelectAllError: 'The upper limit of the folder ({limit}) has been exceeded.',
                    familyRangeError: 'Max {limit} families per save',
                },
            },
        },
        VC: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> VC Investment has been selected.',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: 'Up to {limit} VC Investment documents can be saved at one time',
                },
            },
        },
        MA: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> Merger&Acquisition has been selected.',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: 'Up to {limit} Merger&Acquisition documents can be saved at one time',
                },
            },
        },
        MR: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> Market Report has been selected.',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: 'Up to {limit} Market Report documents can be saved at one time',
                },
            },
        },
        DRUG: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> Drug has been selected.',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: 'Up to {limit} Drug can be saved at one time',
                },
            },
        },
        CLINICAL: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> Clinical has been selected.',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: 'Up to {limit} Clinical documents can be saved at one time',
                },
            },
        },
        sequence: {
            selected: 'Selected',
            sequences: 'Sequences',
        },
    },
};
